import React,{Component,Fragment} from 'react';
import styles from './index.module.scss'
import { withRouter } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import ArrowLeft from '@assets/icons/arrow-left.svg'
import SDK from '../../sdk/utils'
@inject('tabBar')
class Tapbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            toggle:true,
            show:true,
        }
        this.handleClick = this.handleClick.bind(this)
        this.pageBack = this.pageBack.bind(this)
    }
    componentDidMount() {
        if(window.location.hash === '#/superMember' || window.location.hash === '#/superMember?oversea=0' || window.location.hash === '#/superMember?oversea=1') {
            this.setState(() => {
                return {toggle : false}
            })
        }
        this.isActivity();
        // protocol-auto 页面废弃
        if(window.location.hash.match('#/protocol-vip') ) {
            this.setState(() => {
                return {show:false}
            })
        }
        // 路由监听
        this.props.history.listen((location) => {
            if(location.pathname === '/protocol-vip') {
                this.setState(() => {
                    return {show:false}
                })
            }
            if(location.pathname === '/sale') {
                this.setState(() => {
                    return {show:false}
                })
            }
            // else {
            //     this.setState(() => {
            //         return {show:true}
            //     })
            // }

            if(location.pathname === '/' || location.pathname === '/detail') {
                this.setState(() => {
                    return {toggle : true}
                })
            } else {
                this.setState(() => {
                    return {toggle : false}
                })
            }
        })
    }
    isActivity() {
        // 活动页面 不带顶栏配置
        if(/activity/.test(window.location.href)) {
            this.setState(() => {
                return {show:false}
            })
        }
    }
    handleClick(e) {
        console.log(e.target.getAttribute('data-type'))
        let path;
        if(e.target.getAttribute('data-type') === 'normal') {

            if(window.dw) window.dw.onEvent('cibaapp_vip_newvip_show', {client: SDK.isIos ? 'ios': 'android',viptype:'common'})
            // path = {pathname:'/',query:{value:123}}
            // let value = 0;
            path = `/`
            this.setState(() => {
                return {toggle : true}
            })
        } else {
            if(window.dw) window.dw.onEvent('cibaapp_vip_newvip_show', {client: SDK.isIos ? 'ios': 'android',viptype:'super'})
            // path = {pathname:'/superMember',query:{value:123}}
            // let value = 1;
            // path = `/superMember/type=${value}`
            path = `/superMember`
            this.setState(() => {
                return {toggle : false}
            })
        }
        this.props.history.push(path);

       // 跳
    }
    back () {
        SDK.pageBack(true)
    }
    pageBack() {
        this.props.history.push(this.props.tabBar.history)
    }
    render() {
        return (
            <Fragment>
                <div className={styles.border}>
                    <div
                    className={`${styles.barContain} ${this.state.show ? '' : styles.noShow}`}>
                        <div className={styles.backBorder}>
                            {/* 返回 */}
                            <div  className={styles.backArrow} onClick={this.back}>
                                <img
                                className={styles.arrowLeft}
                                src={ArrowLeft}
                                alt="back"/>
                            </div>
                            {/* 切换 */}
                            {/* <div onClick={this.handleClick} className={this.state.show ? styles.tabContain : styles.noShow}> */}
                            {/* <div className={styles.vipType} onClick={this.handleClick}>
                                <div className={`${styles.vipmember} ${this.state.toggle ? styles.choice : styles.unUse}`}>
                                    <span className={styles.vipTap} data-type='normal'>词典会员</span>
                                    <span className={this.state.toggle ? styles.borderShow : styles.unUse}></span>
                                </div>
                                <div className={`${styles.vipmember} ${this.state.toggle ? styles.unUse : styles.choice}`}>
                                    <span className={styles.vipTap} data-type='hornor'>荣耀会员</span>
                                    <span className={this.state.toggle ? styles.unUse : styles.borderShow}></span>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default withRouter(Tapbar);